
import React from "react";
import { CheckCircle2, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface RegistrationSuccessProps {
  email: string;
  onClose?: () => void;
}

const RegistrationSuccess: React.FC<RegistrationSuccessProps> = ({ email, onClose }) => {
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <div className="bg-[#222222] text-white p-6 rounded-lg shadow-lg max-w-md w-full mx-auto">
      <div className="flex items-center justify-center mb-4">
        <div className="bg-green-500/20 p-3 rounded-full">
          <CheckCircle2 className="h-8 w-8 text-green-500" />
        </div>
      </div>
      
      <h2 className="text-xl font-bold text-center mb-4">Registrierung erfolgreich!</h2>
      
      <div className="bg-[#333333] rounded-lg p-4 mb-4">
        <div className="flex items-center">
          <Mail className="h-5 w-5 text-[#41c7f0] mr-2" />
          <span className="text-sm">
            Wir haben eine Bestätigungs-E-Mail an <span className="font-medium">{email}</span> gesendet.
          </span>
        </div>
      </div>
      
      <p className="text-gray-400 text-sm mb-6 text-center">
        Bitte überprüfen Sie Ihren Posteingang (und ggf. Spam-Ordner) für weitere Anweisungen.
      </p>
      
      <div className="flex flex-col space-y-3">
        <Button 
          onClick={handleLogin}
          className="w-full bg-[#41c7f0] hover:bg-[#3ab1d9]"
        >
          Weiter zum Login
        </Button>
        
        {onClose && (
          <Button 
            onClick={onClose}
            variant="outline" 
            className="w-full border-gray-700 hover:bg-[#333333]"
          >
            Schließen
          </Button>
        )}
      </div>
    </div>
  );
};

export default RegistrationSuccess;
